import { Component, output, inject } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MobilBytteSelectors } from '@app/sales/modules/mobilephone/states/mobilbytte/mobilbytte.selectors';
import { SpinnerComponent } from '@app/shared/components/atoms/spinner/spinner.component';
import { IceAlertComponent } from '@app/shared/components/molecules/ice-alert/ice-alert.component';
import { IceCheckboxComponent } from '@app/shared/components/molecules/ice-checkbox/ice-checkbox.component';
import { IconNames } from '@app/shared/enums/icon-names';
import { select } from '@ngxs/store';
import { InformationButtonComponent } from '../../../information-button/information-button.component';

@Component({
  selector: 'app-check-imei-step',
  imports: [
    FormsModule,
    ReactiveFormsModule,
    IceAlertComponent,
    IceCheckboxComponent,
    SpinnerComponent,
    InformationButtonComponent,
  ],
  templateUrl: './check-imei-step.component.html',
  styleUrl: './check-imei-step.component.scss',
})
export class CheckImeiStepComponent {
  private formGroupDirective = inject(FormGroupDirective);
  data = inject<{
    equipmentUpgradeAgreementId: number;
  }>(MAT_DIALOG_DATA);

  IconNames = IconNames;

  existingEquipmentUpgradeAgreements = select(MobilBytteSelectors.existingEquipmentUpgradeAgreements);

  howToFindIMEIInquired = output<boolean>();
  isHowToFindIMEIActive = false;

  toggleHowToFindIMEI(): void {
    this.isHowToFindIMEIActive = !this.isHowToFindIMEIActive;
    this.howToFindIMEIInquired.emit(this.isHowToFindIMEIActive);
  }

  get oldIMEI(): string {
    const equipmentUpgradeAgreementId = this.data?.equipmentUpgradeAgreementId;
    if (!equipmentUpgradeAgreementId) {
      return '';
    }

    return (
      this.existingEquipmentUpgradeAgreements().find(agreement => +agreement?.agreementId === equipmentUpgradeAgreementId)
        ?.activeImei || ''
    );
  }

  get checkIMEIForm(): FormGroup {
    return this.formGroupDirective.form;
  }

  get isIMEIMatching(): FormControl {
    return this.checkIMEIForm?.controls?.isIMEIMatching as FormControl;
  }
}
